<template>
  <a-config-provider :locale="locale">
  <div id="app">
    <router-view/>
  </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enquireScreen from './utils/device'

export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    }
  },
  created () {
    let _this = this
    enquireScreen(isMobile => {
      _this.$store.commit('setting/setDevice', isMobile)
    })
  }
}
</script>

<style lang="less">
.pds {
  height: 100%;
  padding: 20px 20px 0;
  overflow: auto;
  &.menuLeft {
    padding: 20px 0 0;
  }
  &.nopd {
    padding: 0;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0,0,0,.2);
  }
  &::-webkit-scrollbar-track {
    border-radius: 3px;
    background: rgba(0,0,0,0);
  }
}
.scrollbar {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0,0,0,.2);
  }
  &::-webkit-scrollbar-track {
    border-radius: 3px;
    background: rgba(0,0,0,0);
  }
}
#app, .ant-layout {
  height: 100%;
}
  :global{
    //拖拽控件全局样式
    .dragable-ghost{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-chose{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-drag{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    //页面切换动画
    .page-toggle-enter-active{
      transition: all 0.2s ease-in 0.25s;
    }
    .page-toggle-leave-active{
      transition: all 0.2s ease-out 0s;
    }
    .page-toggle-enter, .page-toggle-leave-to{
      opacity: 0;
      padding: 0px;
    }
  }
  .flexR {
    display: flex;
    flex-direction: row;
    &.cenX {
      justify-content: center;
    }
    &.cenY {
      align-items: center;
    }
  }
  .flexC {
    display: flex;
    flex-direction: column;
  }
  .flex {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue